angular.module('property-deal')
    .component('propertyDealTransfer', {
        bindings: {
            propertyDealId: '<',
            dateToCheck: '<'
        },
        template: '<div ng-if="$ctrl.transfer">Data przekazania: <span class="bold" ng-class="{ \'text-danger\' : $ctrl.isTooLate($ctrl.calculatedDiff) }">{{$ctrl.transfer.agreementDate | date: "dd.MM.yyyy"}}</span>&nbsp;' +
            '<span ng-if="$ctrl.isTooLate($ctrl.calculatedDiff)" class="small bold text-danger">Przekroczony termin 5 lat </span>' +
            '</div><div ng-if="$ctrl.noTransfer == true"><span class="small bold text-danger">Brak protokołu przekazania lokalu</span></div>',
        controller: function (PropertyDeal) {
            this.$onInit = () => {
                if(this.propertyDealId == null){
                    this.noTransfer = true;
                    return
                }

                PropertyDeal.transfer({id: this.propertyDealId}).$promise
                    .then(result => {
                        this.transfer = result;
                        this.calculatedDiff = this.getDiff()
                    })
                    .catch(() => {
                        this.calculatedDiff = this.getDiff()
                        this.noTransfer = true;
                    })
            }

            this.$onChanges = () => {
                this.calculatedDiff = this.getDiff()
            }

            this.isTooLate = (diff) => {
                if(diff == null)
                    return false

                if(!angular.isNumber(diff.years) || diff.years == null)
                    return false

                if(diff.years < 5)
                    return false

                if(diff.years === 5 && diff.months === 0 && diff.days === 0)
                    return false

                return true
            }

            this.getDiff = () => {
                if (this.dateToCheck == null || this.transfer == null) {
                    return null
                }
                let preciseDiff = moment.preciseDiff(moment(this.transfer.agreementDate).startOf('day'), moment(this.dateToCheck).startOf('day'), true);
                if(preciseDiff === ''){
                    return {
                        years: 0,
                        months: 0,
                        days: 0,
                        hours: 0,
                        minutes: 0,
                        seconds: 0
                    }
                }
                return preciseDiff
            }
        }
    })
